module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card-modal', {
    attrs: {
      "visible": true,
      "title": _vm.title,
      "showPreview": false,
      "okText": 'Confirmar',
      "disableOk": false
    }
  }, [_c('div', {
    staticClass: "content",
    attrs: {
      "id": "modal-edit-content"
    }
  }, [_c('span', {
    staticClass: "icon is-large modal-center-icon"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [_vm._v("\n      Ao remover um slide todo o seu "), _c('b', [_vm._v("conteúdo associado")]), _vm._v(" será também "), _c('b', [_vm._v("removido")]), _vm._v(".\n      "), (!_vm.is_sub) ? _c('span', [_c('br'), _vm._v("Isto inclui "), _c('b', [_vm._v("Slide, Características de Sub-slides e todos os Sub-slides")]), _vm._v(".")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9df6c70e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slide/SlideDeleteModal.vue
// module id = 344
// module chunks = 1